import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Updates certification popup blocks when the selected variant changes.
 * @param {import('@theme/events').VariantUpdateEvent} event
 */
function updateCertificationPopups(event) {
  const html = event.detail?.data?.html;
  if (!html || !(event.target instanceof HTMLElement)) return;

  const section = event.target.closest('.shopify-section, dialog');
  if (!section) return;

  for (const popup of section.querySelectorAll('[data-certification-popup-root]')) {
    if (!(popup instanceof HTMLElement)) continue;

    if (event.detail.data.newProduct) {
      // Combined listing — allow update for matching product context.
    } else if (event.target.dataset.productId !== popup.dataset.productId) {
      continue;
    }

    const popupId = popup.dataset.certificationPopup;
    const newPopup = html.querySelector(`[data-certification-popup-root][data-certification-popup="${popupId}"]`);

    if (!newPopup) {
      popup.setAttribute('hidden', '');
      continue;
    }

    if (newPopup.hasAttribute('hidden')) {
      popup.setAttribute('hidden', '');
    } else {
      popup.removeAttribute('hidden');
    }

    morph(popup, newPopup, { childrenOnly: true });
  }
}

document.addEventListener(ThemeEvents.variantUpdate, updateCertificationPopups);
